import { buildBinderListings } from '@monofe/di';
import bindMiddleware from '../middleware/binder';
import bindReducer from '../reducer/binder';
import bindRender from '../render/binder';
import bindStores from '../store/binder';

export default buildBinderListings([bindMiddleware, bindReducer, bindStores, bindRender]);
